import { render, staticRenderFns } from "./disable-webview.vue?vue&type=template&id=4e689fe8&"
import script from "./disable-webview.vue?vue&type=script&lang=js&"
export * from "./disable-webview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports